import styled from '@emotion/styled';
import shouldForwardProp from '@styled-system/should-forward-prop';
import {
  background,
  BackgroundProps,
  border,
  BorderProps,
  color,
  compose,
  display,
  DisplayProps,
  flexbox,
  FlexboxProps,
  layout,
  LayoutProps,
  position,
  PositionProps,
  space,
  SpaceProps,
  typography,
  TypographyProps,
} from 'styled-system';
import {
  ColorProps,
  CoreBaseProps,
  defineWithTheme,
  WithoutCollidingProps,
} from '../../theming';

export interface BaseButtonProps
  extends CoreBaseProps,
    BackgroundProps,
    BorderProps,
    ColorProps,
    DisplayProps,
    FlexboxProps,
    LayoutProps,
    PositionProps,
    SpaceProps,
    TypographyProps {}

type NonCollidingButtonProps = WithoutCollidingProps<BaseButtonProps, 'button'>;
type NonCollidingButtonKeys = keyof NonCollidingButtonProps;

export const Button = styled<'button', NonCollidingButtonKeys>('button', {
  shouldForwardProp: (prop): prop is NonCollidingButtonKeys =>
    shouldForwardProp(prop as NonCollidingButtonKeys),
})<BaseButtonProps>(
  defineWithTheme('buttons'),
  compose(
    background,
    border,
    color,
    display,
    flexbox,
    layout,
    position,
    space,
    typography
  )
);

export type ButtonProps = React.ComponentPropsWithRef<typeof Button>;
